export const colors = {
  themeDark: "#2C3845",
  themeLight: "#F5F5F5",
  yellow: "#FFBA00",
  translucentDark: "#040E1AAA",
  dark: "#111B28",
};

export const fontSize = {
  xs: ".75rem",
  sm: ".875rem",
  tiny: ".875rem",
  base: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "4rem",
  "7xl": "5rem",
};

export const spacing = {
  xs: ".25rem",
  sm: ".5rem",
  md: "1rem",
  lg: "2rem",
  xl: "4rem",
};

export const breakpoints = {
  md: "640px",
  lg: "1024px",
  xl: "1280px",
};

export const boxShadow = "9px 7px 12px rgb(50,50,50, 0.3)";
